module.exports = __webpack_public_path__ + "static/media/Spartan051_1c.92d14509.svg";